import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBarDesktop from './appBars/AppBarDesktop';
import AppBarTablet from './appBars/AppBarTablet';
import MobileDrawer from './appBars/MobileDrawer';
import TabContent from './TabContent';
import Header from '../components/header/Header';

const styles = {
  root: {
    flexGrow: 1,
  },
};


class TabContainer extends React.Component {
 

  mapOfViewsToIndex = {
    0: 'Home',
    1: 'Undergraduate',
    2: 'Graduate',
    3: 'Projects',
    4: 'About Me'
  
  }

  constructor(props){
    super(props);
    this.state = {
      value: 0,
    };
    this.handleChange = this.handleChange.bind(this);    
  }


  handleChange = (value) => {
    window.scrollTo(0, 0);
    this.setState({ value });
  };

  renderAppBar() {
    if (this.props.deviceType === 'mobile') {
      return <MobileDrawer handleChange={this.handleChange} value={this.state.value} activePage={this.mapOfViewsToIndex[this.state.value]}/>
    }else{
      return <AppBarDesktop handleChange={this.handleChange} value={this.state.value}/>
    }
  }

  renderHeader(){
    if(this.props.deviceType !== 'mobile'){
      return <Header />
    }
  }
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root} style={{ background: 'transparent' }}>
        {this.renderHeader()}
        {this.renderAppBar()}
        <TabContent value={this.state.value} deviceType={this.props.deviceType} handleChangeFromContainer={this.handleChange}/>
      </div>
    );
  }
}

TabContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TabContainer);


// WEBPACK FOOTER //
// ./src/tabs/TabContainer.js